import { ChangeDetectorRef, Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { CookieService } from 'ngx-cookie-service';
import { FormLoginService } from 'src/app/service/form-login.service';
import { LoadingService } from 'src/app/service/loading.service';

@Component({
  selector: 'app-login-existing',
  templateUrl: './login-existing.component.html',
  styleUrls: ['./login-existing.component.scss']
})
export class LoginExistingComponent extends FieldWrapper {

  errorMessage!: string;
  hasError: boolean = false;
  showLink!: string;

  constructor(
    private formLoginService: FormLoginService,
    private loadingService: LoadingService,
    private cookieService: CookieService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  onSubmit() {

    if (this.formControl.valid) {

      const { username, password } = this.model;

      this.loadingService.setLoading(true);
      
      this.showLink = "";
      this.errorMessage = "";
      this.hasError = false;

      this.formLoginService
        .loginUser(username, password)
        .subscribe({
          next: (res: any) => {

            const token = res.token || res.headers?.['X-MC-Id'];

            if (token) {
              this.cookieService.set('mcid_token', token);
              window.location.reload();
            } else {
              this.loadingService.setLoading(false);
            }
          },
          error: (err) => {
            this.loadingService.setLoading(false);
            this.hasError = true;
            this.errorMessage = err.error.message;

            if(err.error.resetToken) {
              this.showLink = err.error.resetToken + "?returnToForm=" + this.props['formId'];
            }

            this.changeDetectorRef.detectChanges();
          }
        });
    }
  }

  get hasErrorValue() {
    return this.hasError;
  }

  set hasErrorValue(hasError) {
    this.hasError = hasError;
  }
}
